import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IRoutingFilterResult } from './RoutingFilterTypes';

export interface IEditRoutingFilterProjectChanges {
  add: string[];
  remove: string[];
}

export interface IEditRoutingFilterChanges {
  domain?: string;
  isBlocked?: boolean;
  poolId?: string | null;
  projects?: IEditRoutingFilterProjectChanges;
}

export interface IEditRoutingFilterParams {
  siteId: string;
  routingRuleId: string;
  routingRuleChanges: IEditRoutingFilterChanges;
}

export class EditRoutingFilterRequest extends Request<IEditRoutingFilterParams, IRoutingFilterResult> {
  constructor(params: IEditRoutingFilterParams) {
    super('editRoutingRule', params);
  }
}
